import { render } from "./document-sidebar.vue?vue&type=template&id=3bc18099"
import script from "./document-sidebar.vue?vue&type=script&lang=js"
export * from "./document-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__